import { combineReducers } from 'redux'
import authInfo from './authReducer'
import alertMessages from './alertMessageReducer'

export default combineReducers({
    authInfo,
    alertMessages
})
